import { render, staticRenderFns } from "./MuscleLogo.vue?vue&type=template&id=1f46e7c1&scoped=true"
import script from "./MuscleLogo.vue?vue&type=script&lang=js"
export * from "./MuscleLogo.vue?vue&type=script&lang=js"
import style0 from "./MuscleLogo.vue?vue&type=style&index=0&id=1f46e7c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46e7c1",
  null
  
)

export default component.exports